// DEV-2065 — Ürün içi entegrasyonlar: program içindeki ilgili alanlarda gösterilen
// tanıtım/yardım videolarının tek merkezî kaydı. Linkler değişirse yalnızca burası güncellenir.
// Değer = YouTube video id'si (https://youtu.be/<id>). Videonun belirli bir dakikadan
// başlaması isteniyorsa id'ye "&t=<saniye>" eklenebilir (ör. "Kd6D8LbHLps&t=74").
export const RehberVideolari = {
  tercihler: "LLRgZWkxmmI",
  kullaniciIzinleri: "QdXzViK-qWE",
  ajanda: "5na5Lqbhl3w",
  vekaletler: "GBNXPUYR3MA",
  buroEkleme: "Kd6D8LbHLps&t=74",
  faizHesaplayici: "Kd6D8LbHLps&t=1230",
  isListesi: "XxWfkN1kfN4",
  notlar: "cD4JUDBIt70",
  dilekceler: "0Dxs7fUD0Og",
  raporlar: "Kd6D8LbHLps&t=1481",
  takipListesi: "NjJ9Dd3UDg0",
  topluXml: "TLInR-8vTU4",
  takipAcma: "rHJqAWLvjT8",
  sifreDegistirme: "jl_kXj5wF2E",
  genelKullanim: "XdiDfWsYeGc",
  hesaplamalar: "Kd6D8LbHLps&t=1775",
  eicraproMtsTakip: "e5yMM7qQt_0",
} as const;
